import { render, staticRenderFns } from "./TransactionManual.vue?vue&type=template&id=22db6baf"
import script from "./TransactionManual.vue?vue&type=script&lang=js"
export * from "./TransactionManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports